import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GQL_Q_GET_AVAILABLE_PROPERTIES_NEW } from '../utils/queries/properties/editorPropertiesQueries';
import { useNotificationManager } from './useNotificationManager';

/**
 * @param {Object?} context
 * @param matchingTypes
 * @param fetchPolicy
 * @param {string?} context.flowId
 * @param {string?} context.stepId
 * @param {boolean?} skip
 * @param parentDataType
 * */
const useGetEditorProperties = (context = {}, matchingTypes = [], fetchPolicy = 'no-cache', skip, parentDataType) => {
  const result = useQuery(GQL_Q_GET_AVAILABLE_PROPERTIES_NEW, {
    variables: { context, matchingTypes, parentDataType: parentDataType || null },
    skip,
    fetchPolicy,
  });
  const getAvailableProperties = useMemo(() => result?.data?.getAvailablePropertiesNew ?? [], [result.data]);

  useNotificationManager('error', result?.error?.message, 'Fetch property list', 5000);

  return { getAvailableProperties, ...result };
};

export { useGetEditorProperties };
